export const HALF_GLASS_WALL_SEGMENT_HEIGHT = 1050; // 半玻璃墙体段高度

export const DEFAULT_SEP_WALL_THICKNESS = 70;

export const MIN_WALL_LENGTH = 200;
export const MAX_WALL_LENGTH = 99999999;
export const MIN_SAGITTA = 100;
export const MIN_CHORD_LENGTH = 100;
export const MAX_SAGITTA = 99999;
export const MAX_CHORD_LENGTH = 99999;
